var _mask, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 26,
    viewBox: "0 0 311 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2225_18461",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H311V26H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309 0V26H313V0H309ZM2 26V0H-2V26H2Z",
    fill: "#8C8C8C",
    mask: "url(#path-1-inside-1_2225_18461)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13L311 13",
    stroke: "url(#paint0_linear_2225_18461)",
    strokeWidth: 9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13H311",
    stroke: "#3C3C3C",
    strokeWidth: 9,
    strokeDasharray: "1 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2225_18461",
    x1: -2.72133e-8,
    y1: 13.5,
    x2: 311,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EC2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E96CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPlaceholder);
export default __webpack_public_path__ + "static/media/slider_placeholder.549d3a72b0887dfe15ff35fdb0ab144b.svg";
export { ForwardRef as ReactComponent };